export const positionsRoute = '/positions/';
export const requestPositionRoute = '/positions/request/';
